const fonts = {
  helvetica: "Helvetica",
  helveticaBold: "Helvetica Boşd",
}

export default fonts
